import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

export const withModalToggle = function(Component) {
  return function(props) {
    const [isModalOpen, toggleModal] = useState(false)

    const location = useLocation()
    const history = useHistory()

    const _toggleModal = (e) => {
      if (e) {
        e.preventDefault()
      }
      toggleModal(!isModalOpen)
    }

    return (
      <Component
        toggleModal={_toggleModal}
        isModalOpen={isModalOpen}
        history={history}
        location={location}
        {...props}
      />
    )
  }
}

export const withDropdown = (Component) =>
  class Dropdown extends React.PureComponent {
    state = {
      dropdownOpen: false,
    }

    toggle = (e) => {
      if (e) {
        e.preventDefault()
      }
      this.setState({
        dropdownOpen: !this.state.dropdownOpen,
      })
    }
    render() {
      return <Component toggle={this.toggle} dropdownOpen={this.state.dropdownOpen} {...this.props} />
    }
  }
